import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import urls, { codeUrl, datasetUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ items }) {
  const itemsWithUrls = items.map((item) => (item.isNew
    ? item.steps.sourceUrl || codeUrl(urls.DATASET, item.code)
    : datasetUrl(item)));

  yield call(listener.closeTab, itemsWithUrls);
}

export function* navigateToNewDataset({ result, previousUrl }) {
  yield call(listener.navigate, {
    type: actions.NEW_DATASET,
    code: result.code,
    description: result.description,
    name: result.name,
    previousUrl,
    url: datasetUrl(result),
  });
}

export default function* datasetsLayout() {
  yield takeEvery(actions.DESTROY_DATASET, closeTab);
  yield takeEvery(actions.NEW_DATASET, navigateToNewDataset);
}
